import React from 'react'
import {IEvent} from '@/features/labeling'
import {ICatalogStats} from '@/components/catalog/stats'
import {IScoreLabel, labelingWidgetConfigDefault} from './default'
import {ITextLabel, labelingWidgetConfigText} from './text'
import {ICategoricalsLabel, labelingWidgetConfigCategoricals, AddWords} from './categoricals'
import {IVadLabel, labelingWidgetConfigVad} from './vad'

export interface ILabelingWidgetConfig<T = object, TProps = ILabelingWidgetProps<T>> {
  canDelete?: boolean
  deleteConfirmText?: string
  control: (props: TProps) => React.JSX.Element | null
  computePredictionStyle?: (data: T) => React.CSSProperties
  computeLabelStyle?: (data: T) => React.CSSProperties | undefined
}

export interface ILabelingWidgetMap {
  default: ILabelingWidgetConfig<any>
  [key: string]: ILabelingWidgetConfig<any>
}

export interface ILabelingWidgetProps<T = object> {
  predictionStats?: ICatalogStats
  selectedEvent: IEvent
  currentLabelData?: T
  disabled?: boolean
  implicitPredictionData?: T
  implicitLabelData?: T
  setCurrentLabelData: (data: T) => void
  deleteLabelData: () => void
}

const labelingWidgetMap: ILabelingWidgetMap = {
  default: labelingWidgetConfigDefault,
  categoricals: labelingWidgetConfigCategoricals,
  vad: labelingWidgetConfigVad,
  summary: labelingWidgetConfigText,
  transcript: labelingWidgetConfigText,
}

export type {IScoreLabel, ITextLabel, ICategoricalsLabel, IVadLabel}

export {
  labelingWidgetMap,
  labelingWidgetConfigDefault,
  labelingWidgetConfigText,
  labelingWidgetConfigCategoricals,
  labelingWidgetConfigVad,
  AddWords,
}
